import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import WSelect from "@/components/form/w-select.vue";
import QuizUtils from "@/util/quizUtils";
import QuizQuestionCorrectionExplanation from "@/components/questions/QuizQuestionCorrectionExplanation.vue";
import WHtmlToolTip from "@/components/tooltip/w-html-tooltip.vue";
import QuizAnswersValidationAlert from "@/components/quiz/QuizAnswersValidationAlert.vue";
import { shuffleArrayNoFixedPoint } from "@/util/arrayUtils";
let QuizPairsMatchingQuestion = class QuizPairsMatchingQuestion extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "userPairsMatching", void 0);
    _defineProperty(this, "questionCustomLabel", '');
    _defineProperty(this, "displayOverallVerdictIcon", false);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "displayAnswersValidationAlert", void 0);
    _defineProperty(this, "answersValidationState", void 0);
    _defineProperty(this, "realtimeUserPairsMatching", []);
    _defineProperty(this, "shuffledMatchingPairs", []);
  }
  mounted() {
    this.initRealtimeUserPairsMatching();
    this.shuffledMatchingPairs = shuffleArrayNoFixedPoint(this.question.matchingPairs);
  }
  initRealtimeUserPairsMatching() {
    if (this.userPairsMatching?.length) {
      this.realtimeUserPairsMatching = structuredClone(this.userPairsMatching);
    }
  }
  get matchingPairs() {
    return this.question.matchingPairs.sort((a, b) => a.position - b.position);
  }
  get overallAnswersVerdictIcon() {
    return this.allPairsMatchingAreCorrect ? 'check-circle-outline' : 'close-circle-outline';
  }
  get overallVerdictIconClass() {
    return this.allPairsMatchingAreCorrect ? 'is-success' : 'is-failure';
  }
  get allPairsMatchingAreCorrect() {
    return this.question.matchingPairs.every(pair => QuizUtils.isPairMatchingCorrect(pair, this.realtimeUserPairsMatching));
  }
  answerStatusClass(pair) {
    if (pair && this.isResultMode) {
      return QuizUtils.isPairMatchingCorrect(pair, this.realtimeUserPairsMatching) ? 'is-success' : 'is-failure';
    }
    return '';
  }
  shouldDisplayPairMatchingCorrection(pair) {
    return this.isResultMode && !QuizUtils.isPairMatchingCorrect(pair, this.realtimeUserPairsMatching);
  }
  answerStatusIcon(pair) {
    if (!pair) {
      return '';
    }
    return QuizUtils.isPairMatchingCorrect(pair, this.realtimeUserPairsMatching) ? 'check-circle-outline' : 'close-circle-outline';
  }
  get pairAnswer() {
    return pair => {
      const answerId = this.realtimeUserPairsMatching.find(userPair => userPair.itemId === pair.id)?.responseRelatedItemId;
      if (answerId) {
        return this.matchingPairs.find(matchingPair => matchingPair.id === answerId) || null;
      }
      return null;
    };
  }
  get pairItemResponseOptions() {
    return this.shuffledMatchingPairs.map(pair => ({
      pair: pair,
      disabled: this.realtimeUserPairsMatching.some(pm => pm.responseRelatedItemId === pair.id)
    }));
  }
  onPairMatchingAnswerChange(pair, responseOption) {
    if (responseOption.disabled) {
      return;
    }
    if (!this.isResultMode) {
      let pairMatching = this.realtimeUserPairsMatching.find(userPair => userPair.itemId === pair.id);
      if (!pairMatching) {
        pairMatching = {
          itemId: pair.id
        };
        this.realtimeUserPairsMatching.push(pairMatching);
      }
      const choosedAnswerId = responseOption.pair.id;
      pairMatching.responseRelatedItemId = choosedAnswerId;
      this.emitPairMatchingUpdate();
    }
  }
  onPairMatchingClear(pair) {
    if (!this.isResultMode) {
      let pairMatching = this.realtimeUserPairsMatching.find(userPair => userPair.itemId === pair.id);
      if (pairMatching) {
        pairMatching.responseRelatedItemId = undefined;
        this.emitPairMatchingUpdate();
      }
    }
  }
  emitPairMatchingUpdate() {
    return this.realtimeUserPairsMatching;
  }
};
__decorate([Prop({
  required: true
})], QuizPairsMatchingQuestion.prototype, "question", void 0);
__decorate([Prop({
  default: []
})], QuizPairsMatchingQuestion.prototype, "userPairsMatching", void 0);
__decorate([Prop], QuizPairsMatchingQuestion.prototype, "questionCustomLabel", void 0);
__decorate([Prop], QuizPairsMatchingQuestion.prototype, "displayOverallVerdictIcon", void 0);
__decorate([Prop({
  default: false
})], QuizPairsMatchingQuestion.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], QuizPairsMatchingQuestion.prototype, "displayAnswersValidationAlert", void 0);
__decorate([Prop({
  default: null
})], QuizPairsMatchingQuestion.prototype, "answersValidationState", void 0);
__decorate([Emit("userPairMatchingUpdate")], QuizPairsMatchingQuestion.prototype, "emitPairMatchingUpdate", null);
QuizPairsMatchingQuestion = __decorate([Component({
  components: {
    QuizAnswersValidationAlert,
    WHtmlToolTip,
    QuizQuestionCorrectionExplanation,
    WSelect,
    QuizQuestionLabel,
    WInput
  }
})], QuizPairsMatchingQuestion);
export default QuizPairsMatchingQuestion;